import { useContext } from "react";
import { MetaforceContext, SelectableTextContext, WebEditorContext } from "../../../../contexts";
import SelectableTextComponent from "./selectableTextComponent";
import * as Constants from "../../../../utils/constants"
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";

export default function SelectableTextSideBar() {
    const { selectedTextPartIdRef } = useContext(SelectableTextContext);
    const { editorFileRef, handleActionMenuBar, setSideBarState } = useContext(WebEditorContext);
    const { themeAndStyle } = useContext(MetaforceContext);
    const { t: te } = useTranslation([resources.edit]);
    const { t: tc } = useTranslation([resources.common]);

    const handleOpen = (value) => {
        if (!value) {
            selectedTextPartIdRef.current = null;
            handleActionMenuBar({
                editorFile: editorFileRef.current,
                actionMenuBar: {
                    selectableTextState: Constants.normalState,
                },
            })
        }

        if (value) {
            setSideBarState(Constants.sideBarState.predefinedTexts);
        } else {
            setSideBarState(Constants.sideBarState.closed);
        }
    }

    return (
        <div className="tw-h-full tw-w-full tw-flex tw-flex-col">
            <div className="tw-flex-shrink-0 tw-border-b">
                {/* Header */}
                <div className={`predefined-text-header tw-px-4 tw-py-6 sm:tw-px-6'`}>
                    <div className="tw-flex tw-items-start tw-justify-between tw-space-x-3">
                        <div className="tw-space-y-1 tw-text-gray-700 text-md tw-font-medium ">
                            {themeAndStyle?.actionButtons?.predefined?.text || tc(translations.common.predefined)}
                        </div>
                        <div className="tw-h-7 tw-flex tw-items-center">
                            <button
                                type="button"
                                className=" tw-rounded-md tw-text-indigo-700 hover:tw-text-gray-500 tw-cursor-pointer tw-mb-2"
                                onClick={() => handleOpen(false)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleOpen(false);
                                    }
                                }}
                            >
                                <span className="tw-sr-only">{te(translations.edit.closePanel)}</span>
                                <XMarkIcon className="tw-h-6 tw-w-6" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw-w-full tw-h-full tw-py-5 tw-px-4">
                <SelectableTextComponent inSidebarDialog={false} />
            </div>
        </div>
    )
}